// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1cEI8","productName":"Table_productName__1wgWb"};